import { useEffect, useReducer } from 'react';

/**
 * Force a rerender whenever the TipTap editor emits a transaction.
 *
 * Mark toggles with an empty selection update "stored marks" without firing
 * the parent `onUpdate` callback — so any UI that reads `editor.isActive(...)`
 * won't reflect the current state unless we subscribe to transactions.
 */
export default function useEditorChromeSync(editor) {
  const [, bump] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    if (!editor) return;
    const sync = () => bump();
    editor.on('transaction', sync);
    return () => {
      editor.off('transaction', sync);
    };
  }, [editor]);
}
